import gsap from 'gsap';

const SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*#############################';

function randomizeText(letters: string[], revealCount: number) {
  return letters
    .map((letter, index) => {
      if (letter.trim().length === 0) return letter;
      if (index < revealCount) return letter;
      return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
    })
    .join('');
}

/**
 * Scrambles the text content of an element and animates it back to the original text.
 * @param {HTMLElement} target - The element whose text to scramble.
 * @param {number} duration - Duration of the scramble animation in seconds (default: 0.4)
 */
export function runScramble(target: HTMLElement, duration = 0.4, orgText: string = '') {
  if (!target) return;
  const originalText = target.textContent ?? '';
  if (!originalText) return;
  const letters = originalText.split('');
  const state = { progress: 0 };
  target.textContent = randomizeText(letters, 0);
  gsap.to(state, {
    progress: 0,
    duration,
    ease: 'power2.out',
    onUpdate: () => {
      const revealCount = Math.floor(state.progress * letters.length);
      target.textContent = randomizeText(letters, revealCount);
    },
    onComplete: () => {
      target.textContent = orgText ? orgText : originalText;
    },
  });
}
